import {useRouteMatch, Switch, Route} from 'react-router-dom';
import {Contracts} from './contracts';
import React, {FC} from 'react';

export const ContractsRoute: FC = React.memo(() => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path}>
        <Contracts />
      </Route>
    </Switch>
  );
});
